import styled from "styled-components";

export const LessorAvatar = styled.img`
  border-radius: 18px;
`;
